import React from 'react';
import RubricEvaluationButton from '../academic-dashboard/components/RubricEvaluationButton';
import './rubric-evaluation.css';

const RubricEvaluation: React.FC = () => {
  return (
    <>
      <div className="rubric-evaluation-page">
        {/* Header */}
        <div className="page-header">
          <div className="header-content">
            <h1 className="page-title">Rubric-Based Submission Evaluation</h1>
            <p className="page-subtitle">
              Automatically evaluate student submissions using AI-powered rubric scoring
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="page-content">
          <div className="info-card">
            <h2>How It Works</h2>
            <ol>
              <li>The system scans all unscored submissions in the database</li>
              <li>For each submission, it checks if the resource has a rubric mapped to it</li>
              <li>AI evaluates the submission against the rubric criteria</li>
              <li>Scores, grades, and feedback are automatically generated and saved</li>
            </ol>
          </div>

          {/* Rubric Evaluation Component */}
          <RubricEvaluationButton />

          <div className="help-card">
            <h3>Requirements</h3>
            <ul>
              <li>Submissions must be in <strong>SUBMITTED</strong> status</li>
              <li>Resources must have a rubric assigned (RubricId)</li>
              <li>Submissions must have text content or data to evaluate</li>
              <li>Rubrics must be enabled and have valid criteria defined</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default RubricEvaluation;
